<template>
  <div
    class="skip-links-content"
    :class="{
      'inside-container': insideContainer,
      'footer-skip-links': onTheBottom,
    }"
  >
    <ul
      class="skip-links"
      :class="{ 'on-the-top': onTheTop, 'on-the-footer': onTheBottom }"
    >
      <li><a href="#main-content">Ir para o corpo do site</a></li>
      <li><a href="#app">Ir para o cabeçalho do site</a></li>
      <li><a href="#footer">Ir para o rodapé do site</a></li>
    </ul>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "AccessibilitySkipLink",
})
export default class AccessibilitySkipLink extends Vue {
  @Prop({ default: false }) readonly onTheTop!: boolean;

  @Prop({ default: false }) readonly insideContainer!: boolean;

  @Prop({ default: false }) readonly onTheBottom!: boolean;
}
</script>

<style lang="scss" scoped>
.skip-links-content {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: left;
  left: -9000px;

  &.inside-container {
    justify-content: left;

    .skip-links {
      width: auto;
      padding: 0 10px 0 10px;
      border: 1px solid #000;
    }
  }

  .skip-links {
    display: flex;

    li {
      padding: 5px 15px;

      a {
        color: #000;
      }
    }
  }

  &:focus-within {
    position: relative;
    left: auto;
    justify-content: right;

    &.footer-skip-links {
      position: absolute;
      bottom: 0;
    }

    .on-the-top {
      width: 100%;
      display: flex;
    }

    .on-the-footer {
      position: absolute;
      bottom: 0;
      background: white;
    }
  }
}
</style>
